import React from 'react'
import { Translate } from 'i18n'
import { LIST } from 'constants/routePaths'
import ItemsClearLink from 'components/ItemsClearLink'
import './style.css'


const AppHeader = ({ closeWidget, pathname }) => {
    const onCloseClick = (e) => {
        closeWidget()
    }

    const isItemsClearLinkVisible = pathname === LIST

    return (
        <header className='app-header'>
            <div className='content-aligner'>
                <h2><Translate value='shoppingList' /></h2>
                <div className='app-header__controls'>
                    { isItemsClearLinkVisible && <ItemsClearLink /> }
                    <a
                        onClick={onCloseClick}
                        className='close-button'>
                        <span className='close-button__text'><Translate value='closeList' /></span>
                        <span className='icon-close close-button__icon' />
                    </a>
                </div>
            </div>
        </header>
    )
}

export default AppHeader
